var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3115 12.7837V1.22981C10.3115 0.903645 10.1819 0.590837 9.95126 0.360203C9.72063 0.129569 9.40782 0 9.08166 0C8.75549 0 8.44268 0.129569 8.21205 0.360203C7.98142 0.590837 7.85185 0.903645 7.85185 1.22981V15.7702C7.85185 16.9517 9.34931 17.4409 10.0583 16.5152L13.6141 12.9595C13.8442 12.7287 13.9733 12.4161 13.973 12.0902C13.9728 11.7644 13.8432 11.452 13.6128 11.2215C13.3824 10.9911 13.07 10.8616 12.7441 10.8613C12.4183 10.8611 12.1056 10.9902 11.8749 11.2203L10.3115 12.7837ZM6.12123 15.7702V1.22981C6.12123 0.0483106 4.62377 -0.440938 3.91475 0.484799L0.358931 4.04052C0.128855 4.27127 -0.000238201 4.5839 3.2997e-07 4.90976C0.000238861 5.23561 0.129789 5.54805 0.360203 5.77846C0.590617 6.00888 0.903056 6.13843 1.22891 6.13866C1.55476 6.1389 1.86739 6.00981 2.09814 5.77973L3.66155 4.21633V15.7702C3.66155 16.0964 3.79111 16.4092 4.02175 16.6398C4.25238 16.8704 4.56519 17 4.89136 17C5.21752 17 5.53033 16.8704 5.76096 16.6398C5.9916 16.4092 6.12117 16.0964 6.12117 15.7702H6.12123Z",
    fill: "#E09200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowIcon);
export default __webpack_public_path__ + "static/media/yellowIcon.8080622ac3463ae11e7a399ee7881afd.svg";
export { ForwardRef as ReactComponent };